import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import i18next from 'i18next';
import { CoreService } from 'src/app/core/services/core.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { ControlErrors } from '../../../shared/utils/generateError';
import { CommonModule } from '@angular/common';
import { I18NextModule } from 'angular-i18next';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  standalone: true,
  selector: 'app-forgot-password-modal',
  templateUrl: './forgot-password-modal.component.html',
  styleUrls: ['./forgot-password-modal.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    I18NextModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class ForgotPasswordModalComponent implements OnInit {
  @ViewChild('autofocus') autofocus!: ElementRef<HTMLInputElement>;

  nis = '';
  correctNis = false;
  errorMessage = '';
  spinner = false;

  forgotPasswordForm: FormGroup = this.fb.group({
    nis: [
      '',
      [Validators.required, Validators.minLength(6), Validators.maxLength(9)]
    ]
  });

  constructor(
    private fb: FormBuilder,
    private coreService: CoreService,
    private router: Router,
    private storageService: StorageService,
    private controlErrors: ControlErrors,
    public dialogRef: MatDialogRef<ForgotPasswordModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { group: string }
  ) {}

  ngOnInit() {
    this.autofocus?.nativeElement?.focus();
  }

  errorMsg(input: string): string {
    if (
      this.forgotPasswordForm?.controls[input]?.invalid &&
      this.forgotPasswordForm?.controls[input]?.touched
    ) {
      return 'error-message';
    } else {
      return 'info-text';
    }
  }

  onSubmit() {
    this.errorMessage = '';
    this.spinner = true;
    this.nis = this.forgotPasswordForm.value.nis || '';
    this.storageService.set('config', this.forgotPasswordForm.value.nis);
    this.coreService.forgotPassword(this.nis).subscribe({
      next: () => {
        this.spinner = false;
        this.dialogRef.close();
        this.router.navigateByUrl('confirm-new-password');
      },
      error: (err) => {
        if (err.status === 412) {
          this.spinner = false;
          this.errorMessage = this.controlErrors.generateError(
            err.error?.message,
            i18next.t('loginNoPss')
          );
        } else {
          this.spinner = false;
          this.errorMessage = this.controlErrors.generateError(
            err.error?.message,
            i18next.t('genericErr')
          );
        }
      }
    });
  }
}
